import React, { Component } from 'react';
import LocalizedStrings from 'react-localization';

const strings = new LocalizedStrings({
  en: {
    menu: {
      docs: 'Documentation',
      support: 'Support',
      legal: 'Legal',
      blog: 'Blog'
    },
    landing: {
      mainSlogan: 'Build an online store without borders',
      emailPlaceholder: 'Enter your email address',
      description: {
        slogan: 'Build your business online',
        text: 'Create an e-commerce website that helps you find and retain customers, drive sales, and manage your day-to-day business in one place.',
      },
      features: {
        main: {
          title: 'Switch to Market8',
          description: 'Bring your business to Market8, no matter which e-commerce platform you\'re currently using.',
        },
        sell: {
          title: 'Sell Everywhere',
          description: 'Use one platform to sell products to anyone, anywhere - online through your website, social media and online store.'
        },
        coverage: {
          title: 'Global Coverage',
          description: 'Market8 removes barriers to international commerce, so you can deliver the experience your customers expect, in any currency or language'
        },
        support: {
          title: 'Get the help you need, every step of the way',
          description: 'Contact support 24/7 whether you\'re troubleshooting issues or looking for business advice.'
        }
      },
      expertise : {
        title: 'Local expertise',
        slogan: 'Grow globally with localized stores',
        description: 'Customers everywhere demand a local shipping experience. Sell in multiple currencies and languages from one Market8 store. Or build custom stores to localize even more.',
        features: {
          sell: {
            text: 'Sell in your customer\'s local currency and get paid in your own currency.',
          },
          risk: {
            text: 'Identify high-risk orders and avoid chargebacks on all payments with fraud analysis.'
          },
          strategy: {
            text: 'Execute your global strategy on our platform that can handle your volume.'
          }
        }
      },
      promo: {
        text: 'Try Market8 for free, and explore all the tools and services you need to start, run, and grow your business.',
        button: 'Start a free trial'
      }
    },
    store: {
      test: 'Test localization',
    },
    shared: {
      trial: 'Start a free trial',
      signUp: "sign up",
      contactUs: "contact us",
      logIn: "log in",
      createBusinessAccount: "create business account",
      solutions: "solutions",
      terminal3Payments: "Terminal3 payments",
      eCommerceShopBuilder: "E-commerce shop builder",
      globalMarketplaces: "Global marketplaces",
      developers: "developers",
      support: "support",
      followUsOnSocialMedia: "Follow us on social media",
      home: "home",
      youAreTooFarFrom: "You are too far from",
      goBack: 'Go back',
    },
    footerCopyrights: {
      footer_termsOfService: 'Terms of Service',
      footer_returnPolicy: 'Return Policy',
      footer_privacyPolicy: 'Privacy Policy',
      footer_dmcaPolicy: 'Dmca Policy',
      footer_cookiesPolicy: 'Cookies Policy',
      footer_aboutUs: 'About us',
      footer_rights: 'Market8.com. All rights reserved',
    },
    termsOfService: {
      meta: {
        title: "Terms of Service | Terminal3",
        description: "Read terms of service of Terminal3. This is an agreement between you as a merchant and Terminal3 as a company.",
      },
      pageTitle: 'Terms of service',
      pageDescription: "This Terms of Service ('Agreement') is a contract between you and Terminal3 Inc. ('Terminal3') and governs your use of Terminal3. By accessing or using Terminal3, you acknowledge that you accept all of the terms and conditions contained in this Agreement. You should read all of these terms carefully. By accessing Terminal3's website, completing a purchase with Terminal3, or otherwise using Terminal3's services, you agree that these Terms of Service form a binding legal contract between you and Terminal3 Inc. ",
      whatWeDo_title: 'What we do',
      whatWeDo_content: "Terminal3 operates a digital e-commerce distribution platform to allow users to purchase digital content and services (the 'Product(s)') that Terminal3 delivers, sells, distributes, manages, and resells on behalf of licensors from around the world. ",
      registeringAccount_title: 'REGISTERING YOUR ACCOUNT',
      registeringAccount_content: "When you purchase a Product from Terminal3, you will have the option to create a user account with Terminal3 (your 'Account'). Your Account will allow you to make purchases quicker when making any purchases from Terminal3. By creating an Account you consent that Terminal3 may store personal information, such as your name, email address, password and other demographic information, always respecting our Privacy Policy. You are the only person responsible for any purchases you make using your Account. If you choose to remain logged into your Account, Terminal3 will recognize you when you return to Terminal3 or visit other publishers who use Terminal3. If you log out, clear the cookies in your web browser, or use a different device, you may also be able to log back into your Account using the email address and password you originally provided to setup your Account. As long as you are logged in, your personal information may be used when you make purchases from publishers who use Terminal3's digital e-commerce distribution platform. You authorize Terminal3, directly or through third parties, to make any inquiries we consider necessary to validate your identity. This may include asking you for further information such as requiring you to provide your date of birth, confirming your email address or funding instruments, verifying your information against third party databases or through other sources, and other information that will allow us to reasonably identify you. ",
      buyingFromT3_title: 'BUYING FROM TERMINAL3',
      buyingFromT3_content: "When you submit a purchase request, your request shall constitute an offer by you to purchase the Products at the price and terms stated at checkout, and is subject to our acceptance of the purchase request. Terminal3 shall only be deemed to accept your purchase request when it has coordinated the delivery of the Products to you and received your payment of the purchase price in the respective payment method you chose to submit the purchase request. All orders are final, non-cancelable, and non-refundable, except if it is required by law. We describe the Products available for purchase as accurately as possible. We warrant that the prices and descriptions on Terminal3 are accurate, complete, reliable, current, and error-free. The descriptions do not constitute an offer and Terminal3 may withdraw them or revise them at any time prior to the time that Terminal3 accepts your purchase. The Product information is made available to Terminal3 by the Product manufacturer or publisher and are merely intended to represent a basic illustration of the Products. The information shall not be construed to constitute a warranty or representation that the Products will conform with the same. You must refer to the manufacturer's warranty documentation to investigate any rights and remedies regarding any available Product warranties. All purchases are subject to your consent to any applicable license agreement or usage terms that are delivered with, included in, or otherwise presented in connection with the Product you purchased. If you do not agree to the terms, do not accept them and do not complete the purchase. We may reject your order (without liability) if we are unable to process or fulfill it. We cannot guarantee that all items are in stock or immediately available when you submit your order. In such a case, we will refund any prior payment that you have made for that item. ",
      delivery_title: 'DELIVERY',
      delivery_content: 'We will use all commercially reasonable efforts to ensure delivery of Products in a timely manner. Except as expressly stated in this Agreement, the risk of loss or damage to the Products passes to you for the Products delivered digitally, upon the provision to you of a download link, via email or other electronic delivery method. If you refuse or fail to take delivery of Products, any risk of loss or damage to the Products shall nonetheless pass to you, and Terminal3 shall remain entitled to payment in full for the Products delivered. ',
      supportTroubleshooting_title: 'SUPPORT & TROUBLESHOOTING',
      supportTroubleshooting_content_1: 'If you have a question about any aspect of your purchase, please contact us so that we can help to resolve the issue. If you have an Account, you can create a support ticket by signing in to your account and providing the necessary information. If you have not created an Account yet, you can sign up for your own Account. You may also email any questions to ',
      supportTroubleshooting_content_link: 'support@terminal3.com',
      supportTroubleshooting_content_2: ' If you believe that your work has been copied and is accessible via the Terminal3 platform in a way that constitutes copyright infringement, please report possible copyright infringement. ',
      changingDeletingAccount_title: 'CHANGING OR DELETING YOUR ACCOUNT',
      changingDeletingAccount_content_1: 'You may view your Account or edit your information by visiting users page. If you want to delete your personal information, change your settings, or stop storing information using your Account, you can send an email to ',
      changingDeletingAccount_link: 'support@terminal3.com',
      privacy_title: 'PRIVACY',
      privacy_content: 'By submitting your personal information to us in relation to a purchase or when registering your Account, you consent to such information being used to fulfill your purchase and be otherwise used by Terminal3 in accordance with our Privacy Policy. We will also use our reasonable efforts to keep your personal information secure.',
      taxesDuties_title: 'TAXES AND DUTIES',
      taxesDuties_content: 'It is our responsibility to determine what, if any, taxes apply to the payments you make, and it is our responsibility to collect, report and remit the correct tax to the appropriate tax authority. Each Product sold, exported, transferred, supplied or licensed by us may be subject to and governed by the laws of the United States and other countries. You agree to comply with all export laws and regulations that apply to the Products. ',
      thirdPartyServices_title: 'THIRD PARTY SERVICES',
      thirdPartyServices_content: "By choosing a particular payment option, you may be redirected to a third party's website to complete a payment. The fact that Terminal3 links to a third party website or service is not an endorsement or representation of any affiliation with that third party, nor is it an endorsement of their privacy or information security policies or practices. Terminal3 does not exercise any control over third party websites or services. By choosing to navigate to third party sites, you agree that Terminal3 is not liable for the content or services of that third party and that you shall be subject to the terms and conditions of the respective third party. By choosing to access or use such third party services, you agree that such services are provided \"as is,\" \"with all faults,\" and without any warranty of any kind. Only use and implement third party services at your own risk. Terminal3 is not liable to you, or any third party, in any way, for any losses, damages, costs or other expenses arising from your use of third party services. ",
      representationsWarranties_title: 'REPRESENTATIONS AND WARRANTIES',
      representationsWarranties_content: 'By using Terminal3 or creating an account, you represent and warrant that you are at least 18 years of age and that you will not use any Terminal3 system and services for any fraudulent, unlawful or abusive purpose. You also confirm that you are not a Sanctioned Entity or Individual and will not use the Terminal3 Services in connection with any of the Restricted Businesses. A list of the Restricted Businesses can be found here. When you provide a funding instrument to Terminal3, you confirm that you are permitted to use that funding instrument. When you fund a transaction, you authorize Terminal3 to charge the full amount to the funding instrument you designate for the transaction. You also authorize us to collect and store that funding instrument, along with other related transaction information. Terminal3 does not guarantee and is not responsible to perform any verification of information provided by users, including with regard to their legal capacity or age. The accuracy of this statement is your sole responsibility. This Section shall survive the termination of the Agreement. ',
      disclaimers_title: 'DISCLAIMERS',
      disclaimers_content: 'BY ACCEPTING THIS AGREEMENT, YOU UNDERSTAND AND AGREE THAT TERMINAL3 IS NOT THE MANUFACTURER OF THE PRODUCTS WE SELL TO YOU. TO THE FULLEST EXTENT PERMISSIBLE UNDER APPLICABLE LAW, THE PRODUCTS THAT YOU PURCHASE FROM US AND TERMINAL3 SERVICES ARE PROVIDED TO YOU \'AS IS,\' AND YOUR USE IS AT YOUR OWN RISK. WE DO NOT MAKE, AND HEREBY DISCLAIM, ANY AND ALL EXPRESS, IMPLIED OR STATUTORY WARRANTIES, INCLUDING IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NONINFRINGEMENT OF THIRD PARTY RIGHTS, AND ANY WARRANTIES ARISING FROM A COURSE OF DEALING, USAGE, OR TRADE PRACTICE. UNLESS AGREED OTHERWISE OR REQUIRED BY APPLICABLE LAW, ANY WARRANTIES PROVIDED IN RELATION TO PRODUCTS OR TERMINAL3 SERVICES ONLY EXTEND TO YOU ON THE UNDERSTANDING THAT YOU ARE A USER AND NOT A RESELLER OF THOSE PRODUCTS OR TERMINAL3 SERVICES. TERMINAL3 DOES NOT WARRANT THAT THE PRODUCTS OR THE TERMINAL3 SERVICES WILL BE UNINTERRUPTED OR ERROR FREE. Terminal3 SHALL NOT BE RESPONSIBLE FOR ANY SERVICE INTERRUPTIONS, INCLUDING, BUT NOT LIMITED TO, SYSTEM FAILURES OR OTHER INTERRUPTIONS THAT MAY AFFECT THE RECEIPT, PROCESSING, ACCEPTANCE, COMPLETION OR SETTLEMENT OF ANY SALES TRANSACTIONS. ',
      limitationOfLiability_title: 'LIMITATION OF LIABILITY',
      limitationOfLiability_content: 'EXCEPT WHERE OTHERWISE REQUIRED BY LAW, IN NO EVENT SHALL TERMINAL3 BE RESPONSIBLE OR LIABLE TO YOU OR ANY THIRD PARTY UNDER ANY CIRCUMSTANCES FOR ANY INDIRECT, CONSEQUENTIAL, SPECIAL, PUNITIVE OR EXEMPLARY, DAMAGES OR LOSSES, INCLUDING BUT NOT LIMITED TO DAMAGES FOR LOSS OF PROFITS, GOODWILL, USE, DATA, OR OTHER INTANGIBLE LOSSES WHICH MAY BE INCURRED IN CONNECTION WITH TERMINAL3 OR ANY PRODUCTS PURCHASED, RECEIVED, SOLD, OR PAID FOR BY WAY OF TERMINAL3, REGARDLESS OF THE TYPE OF CLAIM OR THE NATURE OF THE CAUSE OF ACTION, EVEN IF TERMINAL3 HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE OR LOSS. IN NO EVENT SHALL TERMINAL3\'S AGGREGATE LIABILITY (WHETHER FOR CONTRACT, TORT, OR ANY OTHER LEGAL THEORY) ARISING FROM OR RELATING TO THE AGREEMENT EXCEED THE AMOUNT YOU ACTUALLY PAID FOR THE APPLICABLE PRODUCTS WHICH GIVE RISE TO SUCH LIABILITY. NOTWITHSTANDING THE FOREGOING, NOTHING CONTAINED IN THESE TERMS LIMIT TERMINAL3\'S LIABILITY TO YOU FOR ANY LIABILITY TO THE EXTENT SUCH LIABILITY CANNOT BE EXCLUDED OR LIMITED AS A MATTER OF APPLICABLE LAW. Each party acknowledges that the other party has entered into the Agreement relying on the limitations of liability stated herein and that those limitations are an essential basis of the bargain between the parties. In addition to and without limiting any of the foregoing, no party shall have any liability for any failure or delay resulting from any condition beyond the reasonable control of such party, including but not limited to governmental action or acts of terrorism, earthquake, fire, flood or other acts of God, labor conditions, power failures and Internet disturbances. ',
      indemnificationTitle: 'INDEMNIFICATION',
      indemnificationContent: "You agree to defend, indemnify and hold harmless us, our subsidiaries and affiliates, and their respective directors, officers, employees and agents from and against all claims and expenses, including attorneys' fees, arising out of or related to the Products you purchase from Terminal3 or your violation of this Agreement. To the fullest extent permitted by law, we shall have no liability to you in the event of the Products or Terminal3 services infringing or being alleged to infringe the proprietary rights of any third party. In the event that the Products are or may be the subject of patent, copyright, database right, registered design, trademark or other rights of any third party, you should refer to the relevant terms of the Product manufacturer. We shall be obliged to transfer to you only such right or title as we have.",
      disclosuresTitle: 'DISCLOSURES AND NOTICES',
      disclosuresContent: 'By registering for an Account or making a purchase from Terminal3, you consent to receive all disclosures and notices electronically and that Terminal3 may post such disclosures and notices on our website or email them to the email address you provide in your Account. You also agree that electronic disclosures and notices have the same meaning and effect as if we had provided you with a paper copy. Such disclosures and notices shall be considered to be received by you within 48 hours of the time it is posted to our website or emailed to you unless we receive notice that the email was not delivered.',
      changesAgreementTitle: 'CHANGES TO THE AGREEMENT',
      changesAgreementContent: 'Terminal3 may, in its discretion, make changes to this Agreement. If Terminal3 considers any such changes material, we will notify you in accordance to the terms of this Agreement. We may also provide notices of changes to the Agreement or other matters by displaying links to notices on the Terminal3 Website. By continuing to use Terminal3 after those changes are made, you are expressing and acknowledging your acceptance of the changes.',
      assignmentTitle: 'ASSIGNMENT',
      assignmentContent: 'You may not assign this Agreement or any rights or obligations hereunder, by operation of law or otherwise, without our prior written approval and any such attempted assignment shall be void. We reserve the right to freely assign the Agreement and the rights and obligations hereunder, to any third party without notice or consent. Subject to the foregoing, the Agreement shall be binding upon and inure to the benefit of the parties hereto, their successors and permitted assigns.',
      terminationTitle: 'TERMINATION',
      terminationContent: "Terminal3 reserves the right to terminate your use of Terminal3's services, including your Terminal3 Account, if you violate this Agreement or any other applicable terms posted on the Terminal3 website or for any other reason in our sole discretion. In the event of any termination, Terminal3 may delay payment to Publisher for up to six months, or longer if necessary, and may deduct from the payout any amounts necessary to satisfy any debts or obligations that result from the Publisher's account. Following the reconciliation of any anticipated obligations, Terminal3 will remain liable for any amount remaining of Total Net Revenue due to Publisher through the effective date of termination and such obligation to pay shall survive any termination of this Agreement.",
      generalProvisions_title: 'GENERAL PROVISIONS',
      generalProvisions_content_1: "Terminal3's failure to exercise or enforce any right or provision of the Agreement will not be considered a waiver of that right or provision. Any dispute hereunder will be privately negotiated in good faith between the parties within forty-five (45) calendar days commencing upon written notice from one party to the other. If the parties fail to privately resolve any dispute, the parties shall submit to arbitration performed by a mutually agreed upon arbitration provider in San Francisco, California. This Agreement shall be governed by and construed in accordance with the laws of the State of California, without giving effect to principles of conflicts of law. In the case that the arbitration provision does not apply to you or a particular dispute, you expressly agree that any action at law or in equity arising out of or relating to this Agreement will be filed only in the state or federal courts in and for San Francisco, California, and you hereby consent and submit to the personal and exclusive jurisdiction of such courts for the purposes of litigating any such action. If any provision of the Agreement shall be adjudged by any court of competent jurisdiction to be unenforceable or invalid, that provision shall be limited or eliminated to the minimum extent necessary so that the Agreement shall otherwise remain in full force and effect and remain enforceable between the parties. Headings are for reference purposes only and in no way define, limit, construe or describe the scope or extent of such section. The Agreement, including Terminal3's policies governing the services referenced herein, constitutes the entire agreement between you and Terminal3 with respect to the use of the Service. The Agreement is not intended and shall not be construed to create any rights or remedies in any parties other than you and Terminal3 which each shall be a third party beneficiary of the Agreement, and no other person will have the ability to assert any rights as a third party beneficiary under the Agreement. This Section shall survive the termination of the Agreement.",
      generalProvisions_content_2: `Terminal3 Inc., 
      San Francisco, CA 94103,
      United States
     `,
      generalProvisions_content_3: 'You may reach us via e-mail at info@terminal3.com',
      generalProvisions_content_4: `Privacy Policy effective as of April 20, 2010 
      Privacy Policy last updated on January 31, 2017 `,
    },
    privacyPolicy: {
      meta: {
        title: "Privacy Policy | Terminal3",
        description: "Read the Privacy Policy for Terminal3. Learn about protection and usage of the collected information.",
      },
      pageTitle: 'Privacy policy',
      pageDescription_1: `This Privacy Policy (hereinafter “Policy”) describes how we deal with your “personal data”
        (that is, information about any identified or identifiable living persons, hereinafter also referred to as “data”). 
        For the purposes of the European Union General Data Protection Regulation (“GDPR”), 
        we are the data controller inrelation to personal data collected by us. 
        Please read on to find out what kinds of personal data we collect, how we use and protect it, 
        to whom we disclose it and how you can access and rectify it or request that we stop processing it.`,
      pageDescription_2: `By using the Terminal3 site (hereinafter “Site”) and/or the Terminal3 services (hereinafter “Services”), 
        you accept this Policy, our terms of service and our cookie policy. 
        Please do not use the Site and/or Services unless you have read this Policy, our cookies policy and our terms of service. 
        If you use the Site and/or the Services, we will assume that you do accept it.`,
      pageDescription_list: [
        {
          text: `We collect and process data you enter while using the Services, 
          the data you provide to the merchants who have partnered with us, and data collected pursuant to our %cp. 
          We also track your IP addresses and data about the devices you use when accessing the Site or the Services.`
        },
        {
          text: `We use the data we collect to process transactions you have initiated through the Services, 
          to verify your identity, and  carry out our legal and contractual obligations which include processing transactions 
          and preventing fraud and money laundering on the Services.`
        },
        {
          text: `We may disclose data we gain during your use of the Services to your bank, 
          our third-party partners to the extent necessary to provide the Services, 
          or to law enforcement upon receipt of a valid legal request.`
        }
      ],
      pageDescription_3: 'More information about our collection, use and disclosure of your data, and your rights can be found in the sections below.',
      dataCollection__title: 'Data Collection',
      dataCollection__description: `We collect data about you directly from you and from third parties, as well as automatically through your use of the Services under the following circumstances.`,
      dataCollection__list: [
        {
          title: `When you access the Site or visit a page that integrates the Services: `,
          description: `Our Services gather data automatically transmitted from the device(s) you use to
          access the Site or other sites integrating the Services, such as your IP address, unique device identifier, 
          browser information, and system information (e.g., operating system). 
          This information, alone or combined with other information, may allow you to be identified.`
        },
        {
          title: `When you complete a transaction using the Services: `,
          description: `During the course of a transaction, you will be prompted to enter certain information about yourself 
          if you have not already provided it as part of the account creation process. 
          This data may include your full name, address, date of birth, and details about the payment method you are using.`
        },
        {
          title: `When personal data is provided to us by third-party sources in connection with your use of the Services: `,
          description: `Merchants for whom we process payments for may send us any required data you have provided them, 
          including your personal details (e.g., name, contact information) and details regarding your past and current purchases 
          and activity on their site. Additionally, we may receive data about you from the provider of the payment method 
          you use on the Services to the extent such data is necessary to process your transaction, 
          or if it later becomes necessary during an investigation in connection with fraudulent or otherwise suspicious transactions.`
        },
        {
          title: `When you communicate with our customer support team: `,
          description: `If you initiate communication with our customer support team, you may be prompted to provide additional 
          information about yourself and your transaction. Additionally, our customer support team may contact you 
          to request further proof of personal identity, such as a new or updated picture of a legal identification document 
          in order to ensure your transaction is valid or to the extent it otherwise may be necessary to comply with 
          our legal obligations as a financial institution.`
        }
      ],
      dataUse_title: 'Data Use',
      dataUse_description: 'We will only use or process your data for the following legal basis:',
      dataUse__list: [
        {
          title: `To offer the Services: `,
          description: `We will use your personal data as necessary to provide the Services, including to the extent 
          necessary to process the transaction you initiated, verify your identity, authenticate your access of a user account, 
          and communicate with you about the Services. For example, when you consent by providing your information for a purchase transaction.`
        },
        {
          title: `To manage risk and protect you, the Site and the Services: `,
          description: `Fraud prevention is a critical part of providing payment services, and we use your data to help us detect and prevent fraud.`
        },
        {
          title: `To comply with our legal obligations: `,
          description: `Our obligations may include complying with all applicable anti-money laundering laws, anti-terrorist financing laws, 
          financial services regulations, as well as our contractual obligations with third-party partners who provide or 
          help to provide any payment method(s) you use on Services. For example, we are required 
          to disclose personal data to a court or governmental authority.`
        },
        {
          title: `For our other legitimate interests: `,
          description: `We may need to use your personal data in order to enforce our contracts and terms of service and 
          monitor activity on the Site. For example, we process your payment information when you purchase a service or 
          product from merchants that use the Services for processing payments.`
        },
      ],
      dataDisclosure_title: 'Data Disclosure',
      dataDisclosure_description: `Your data may be disclosed to third-parties. Your privacy is important to us so we have taken 
      measures to ensure that all of the entities we share your personal data/information with have 
      implemented strong data privacy and data protection practices of a level comparable to that 
      which we employ. Your personal data may be disclosed under the following circumstances:`,
      dataDisclosure_list: [
        {
          title: `When our related affiliates or subsidiaries require the data to help provide the Services: `,
          description: `We have related affiliates and subsidiaries around the world that assist in providing the Services. 
          We may provide your data to these affiliates or subsidiaries for any of the purposes we would ourselves use your data, 
          including carrying out the transaction you requested, preventing fraud or illegal activity, 
          and enforcing our terms and conditions. If we disclose your personal data to these affiliates or subsidiaries, 
          their use of the personal data will subject them to this Policy.`
        },
        {
          title: `When our third-party payment partners need it to process a transaction you initiated: `,
          description: `We have contracts with banks and other third-party financial institutions for every payment method we offer on the Services. 
          When you authorize a transaction, we will transmit to the relevant third-party data they require to process the transaction. 
          The data that is required will vary by payment type, but may include your name, address, 
          and details of the purchase you are attempting to make.`
        },
        {
          title: `When our merchants need the data in connection with a transaction you initiated: `,
          description: `Where necessary, we will share certain data about you with our third-party merchants 
          to help facilitate the transactions. This data will never include your sensitive payment details (such as credit card number).`
        },
        {
          title: `When other third-parties that provide us with ancillary services in order to facilitate the Services: `,
          description: `This includes our server hosting providers and independent auditors whom we engage 
          for the purposes of analyzing our compliance with the law or relevant independent standards.`
        },
        {
          title: `To the extent required by law: `,
          description: `We will share your data with third-parties to the extent we are required to do so by law. 
          For example, we are required by law to undergo certain routine audits, which may require us to share your data 
          with the third-party auditors we have engaged in relation to these requirements. Additionally, we may have 
          to disclose your data when we receive a valid subpoena or other law enforcement request, 
          or when the law requires us to affirmatively notify law enforcement in order to prevent harm or illegal activity. 
          The necessity of all such disclosures will be determined in our sole discretion.`
        },
        {
          title: `To the extent our legitimate interests require us to do so: `,
          description: `We may transmit your data to our third-party partners for inclusion on their blacklists 
          or lists of terminated merchants, or to help us engage in our fraud reduction efforts, 
          to support our corporate governance activities, to facilitate the sale or other transfer of all or part of our business, 
          or to protect us or our Services.`
        }
      ],
      dataRetention_title: 'Data Retention',
      dataRetention_description: `We may be required by law to retain some of your data for so long as necessary, often for a 
      period of several years for the purposes of combating fraud and for reporting purposes. 
      We may additionally retain your data for a longer period than is required by law to the extent it is in our 
      legitimate interests to do so (for example, we may retain it to prevent fraud on the Services) and is not otherwise prohibited by law.`,
      dataLocation_title: 'Data Location',
      dataLocation_description: `We use servers located in the European Union and the United States to store personal data 
      gathered by the Services. Additionally, to the extent we transfer your data to a third-party, 
      including our related affiliates, as described in this Policy, these third-parties may be located 
      outside our usual business location and your country of residence. In all such cases, data 
      transfers will be carried out only after we ensure the third-party provides comparable levels of 
      data protection and that they will use your data only for the purposes set out in this Policy.`,
      dataProtection_title: 'Your Data Protection Rights',
      dataProtection_description: `Subject to certain exemptions, and in some cases dependent upon the processing activity we 
      are undertaking, you have certain rights in relation to your personal data. Every user is entitled to the following:`,
      dataProtection_list: [
        {
          title: `The right to access - `,
          description: `You can confirm with us whether or not we have processed your personal data. 
          If we processed your personal data, you have the right to request for copies of your personal data. 
          We may charge you a small fee for this service.`
        },
        {
          title: `The right to rectification - `,
          description: `You have the right to request that we correct any information about you that you believe is inaccurate. 
          You also have the right to request that we complete information about you that you believe is incomplete.`
        },
        {
          title: `The right to erasure - You have the right to request that we erase your personal data, under certain conditions. 
          We may not be required to comply with your request to delete personal data if the processing of your personal 
          data is necessary for compliance with a legal obligation or for the establishment, exercise, or defense of legal claims.`,
          description: ``
        },
        {
          title: `The right to restrict processing - `,
          description: `You have the right to request that we restrict the processing of your personal data, 
          under the following circumstances: (i) you contest the accuracy of your personal data; 
          (ii) the processing is unlawful but you wish to restrict rather than prohibit the processing of your personal data; 
          (iii) the purposes for processing your personal data no longer exist, but you require the personal 
          data for the establishment, exercise, or defense of legal claims; or 
          (iv) you have legitimately objected to the processing of your personal data and the processing is therefore 
          restricted pending the verification of whether the legitimate grounds of the controller override your objection.`
        },
        {
          title: `The right to object to processing - `,
          description: `You have the right to object to our processing of your personal data in cases 
          where the processing is based on our legitimate interests or a third- party’s legitimate interests 
          if you believe your fundamental rights and freedoms outweigh our legitimate interests. 
          If you raise an objection, we have an opportunity to demonstrate that 
          we have compelling legitimate interests for the processing that override your rights and freedoms.`
        },
        {
          title: `The right to data portability - `,
          description: `To the extent that we process your personal data, (i) based on your consent or under contractual obligations, 
          and (ii) through automated means, you have the right to request that we transfer your personal data 
          that we have collected to another organization where technically feasible, or directly to you in a structured, 
          commonly used, machine-readable format.`
        },
        {
          title: `The right to withdraw consent at any time - `,
          description: `If processing is based on consent, you can withdraw your consent at anytime. 
          Your withdrawal of consent does not affect the lawfulness of processing based on consent before your withdrawal.`
        },
        {
          title: `The right to lodge a complaint with a supervisory authority - `,
          description: `If applicable under Article 77 of the GDPR, you can lodge a complaint with a supervisory authority, 
          in particular in the member state of the European Union of your habitual residence, 
          place of employment or place of alleged infringement.`
        }
      ],
      childrenPrivacy_title: 'Children’s Privacy',
      childrenPrivacy_description: `We do not process personal data of children under the minimum legal age pursuant 
      to local legal requirements in the state, province, country or jurisdiction of residence. 
      We take appropriate measures to ensure that children do not use the Services. 
      If you discover that a child under age has provided us with his/her personal data, please contact us at %mst.`,
      contactUs_title: 'Contact Us',
      contactUs_description: `To exercise your data protection rights as listed above, please send the privacy request 
      form to %mst. Please note that we may request for additional identification 
      including photo identification in order to verify and grant an individual access to their requested personal data. 
      For further questions and concerns, you may reach our Data Protection Officer at %mtd.`,
      changesToPolicy_title: 'Changes to this Policy',
      changesToPolicy_description_1: `This Policy is current as of the Effective Date set forth below. 
      We may change this Policy from time to time, so please be sure to check back periodically. 
      We will post any changes to this Policy on the Site and the Services. 
      If we make any changes to this Policy that materially affect our practices with regard to the personal 
      data that we have previously collected from you, we will endeavor to provide you with notice in advance of 
      such change by highlighting the change the Site and the Services.`,
      changesToPolicy_description_2: 'Privacy Policy effective as of October 23, 2019.'
    },
    dmcaPolicy: {
      meta: {
        title: "DMCA Policy | Terminal3",
        description: "Read the DMCA Policy for Terminal3 to discover policy on infringing content, trademark ad copyright infringement claims, and more.",
      },
      pageTitle: 'Policy on Infringing Content',
      pageDescription_1: 'Terminal3 Inc. (“Terminal3”) takes reports of illegal activity such as copyright and trademark infringement seriously. Terminal3 respects the intellectual property rights of others and abides by European Union intellectual property laws, including the requirements of the The Copyright Directive. Terminal3 requires each of its merchants to pledge that they will not engage in any illegal activity and will not violate the rights of third parties. ',
      pageDescription_2: 'In response to a valid claim of infringement regarding any merchant using Terminal3’s services, Terminal3 may take action when necessary including disconnecting or disassociating the Terminal3 services from the infringing content. ',
      trademarkCopyrights_title: 'TRADEMARK AND COPYRIGHT INFRINGEMENT CLAIMS',
      trademarkCopyrights_content_1: 'Pursuant to applicable law and the Directive 2001/29/EC of the European Parliament and of the Council, Terminal3 applies the following process to any third party claims of infringement. In order to investigate any alleged infringement, Terminal3 asks the owner or its authorized agent to submit a notice of infringement containing the following information: ',
      trademark_listItems_1: 'Your name and email address.',
      trademark_listItems_2: 'Name of the intellectual property owner (if different).',
      trademark_listItems_3: 'Information about the intellectual property: ',
      trademark_listItems_3_1: 'Trademark name or description of the copyrighted material (attach the registration certificate, if applicable).',
      trademark_listItems_3_2: 'Registration Number (if applicable).',
      trademark_listItems_3_3: 'Registration Country.',
      trademark_listItems_3_4: 'Company name and website (if the owner is a company).',
      trademark_listItems_4: 'Location of the infringing content (please copy and paste the URL from your browser).',
      trademark_listItems_5: 'Specific description of how your intellectual property rights are allegedly infringed.',
      trademark_listItems_6: 'This statement: "I swear, under penalty of perjury, that the information provided in this notice is accurate, and I am the owner or am authorized to act on behalf of the owner of an exclusive right to the intellectual property described herein."',
      trademark_listItems_7: 'Your physical signature or digital signature.',
      trademarkCopyrights_content_2: 'Please send the completed notice to Terminal3 as follows: ',
      trademarkCopyrights_content_3: 'by email: ',
      trademarkCopyrights_link_1: 'info@terminal3.com',
      trademarkCopyrights_content_4: 'and by mail: ',
      trademarkCopyrights_content_5: `Terminal3 Inc., 
      San Francisco, CA 94103,
      United States
     `,
      trademarkCopyrights_content_6: 'By submitting a notice of infringement to Terminal3, you authorize Terminal3 or its agent to forward the information in your notice to the person who is allegedly responsible for the infringing content. ',
      trademarkCopyrights_content_7: 'Please be aware that under federal law, any person who makes a false claim or knowingly submits an inaccurate notice of infringement may be personally liable to Terminal3, the alleged infringer, the intellectual property owner, and/or any other injured party. Such false statements may cause you to be liable for any monetary damages, court costs, and attorney’s fees incurred by any party who is injured because they relied on your representations.',
      trademarkCopyrights_content_8: 'This information should not be construed as legal advice and you should seek the advice of legal counsel before submitting a notice or claim regarding infringement.',
    },
    cookiesPolicy: {
      meta: {
        title: "Cookies Policy | Terminal3",
        description: "Terminal3 cares about its visitors and wants to provide a convenient website. We use cookies to improve the user experience.",
      },
      pageTitle: 'COOKIES POLICY',
      aboutCookies_title: `ABOUT THIS COOKIE POLICY`,
      aboutCookies_content: `This Cookie Policy explains what cookies are and how we use them. 
      You should read this policy so you can understand what type of cookies we use, the information 
      we collect using cookies and how that information is used. For further information on how we use, 
      store and keep your personal data secured, see our Privacy Policy.`,
      whatAreCookies_title: `WHAT ARE COOKIES?`,
      whatAreCookies_content_1: `Cookies are little text files which are stored on the browser or hard drive of your computer 
      or mobile device when you visit a webpage or application. Cookies work to make your experience browsing our site 
      as smooth as possible and they remember your preferences so you don’t have to insert your details again and again.`,
      whatAreCookies_content_2: `There are different types of cookies. Some cookies come directly from our website and 
      others come from third parties which place cookies on our site.`,
      howDoWeUseCookies_title: `HOW DO WE USE COOKIES?`,
      howDoWeUseCookies_content: `We use cookies to enhance your browsing experience. Our cookies and similar technologies 
      have different functions. They are either necessary for the functioning of our services, help us improve our performance, 
      give you extra functionalities, or help us to serve you relevant information. We use these cookies to identify and 
      prevent potential security risks and to store preferences set by our users such as account name, language, and location. 
      Cookies can be used to analyze your activity in order to improve the Sites. For example, 
      using Cookies we can look at aggregate patterns like the average number of job searches that users perform. 
      We can use such analysis to gain insights about how to improve the functionality and user experience of the Sites.`,
      whatTypesOfCookies_title: `WHAT TYPES OF COOKIES DO WE USE?`,
      whatTypesOfCookies_content: `The types of cookies we use are listed below.`,
      whatTypesOfCookies_list: [
        {
          title: `Persistent Cookies. `,
          content: `We use Persistent Cookies to improve your experience of using our website. This includes recording 
          your acceptance of our Cookie Policy to remove the cookie message which first appears when you use the website.`
        },
        {
          title: `Session Cookies. `,
          content: `Session Cookies are temporary and deleted from your machine when your web browser closes. 
          We use Session Cookies to help us track internet usage as described above.`
        },
        {
          title: `Essential Cookies. `,
          content: `We may use cookies or other similar technologies that are necessary to the operation of our sites, 
          services, applications, and tools. This includes technologies that allow you access to our websites, services, 
          applications, and tools that are required to identify irregular site behavior, prevent fraudulent activity 
          and improve security or that allow you to make use of our functions such as shopping-carts, saved search, or similar functions.`
        },
        {
          title: `Functional Cookies. `,
          content: `Functional Cookies let us operate the website in accordance with the choices you make. These cookies 
          permit us to “remember” you in-between visits. For instance, we will recognize your user name and remember 
          how you customized the websites and its services, for example by adjusting text size, fonts, languages 
          and other parts of web pages that are alterable, and provide you with the same customization during future visits.`
        },
        {
          title: `Performance Cookies. `,
          content: `We may use Performance Cookies or other similar technologies to assess the performance of our websites, 
          applications, services, and tools, including as part of our analytic practices to help us understand 
          how our visitors use our websites, determine if you have interacted with our messaging, determine whether 
          you have viewed an item or link, or to improve our website content, applications, services, or tools.`
        },
        {
          title: `Marketing/Third Party Cookies. `,
          content: `Marketing/Third Party Cookies originate from external advertising companies (among others) 
          and are used to gather information about the websites visited by you, in order to create targeted advertising for you.`
        }
      ],
      howCanYouAvoid_title: `HOW CAN YOU AVOID USING COOKIES ON THIS WEBSITE?`,
      howCanYouAvoid_content_1: `Within your browser, you can choose whether you wish to accept cookies or not. 
      Different browsers make different controls available to you. Generally, your browser will offer you the choice to accept, 
      refuse or delete cookies at all times, or those from providers that website owners use i.e. third party cookies, 
      or those from specific websites. Here are helpful links in disabling cookies in your browser. `,
      howCanYouAvoid_list: [
        {
          title: `Chrome:`,
          link: `https://support.google.com/chrome/answer/95647?hl=en&co=GENIE.Platform=Desktop`
        },
        {
          title: `Internet Explorer:`,
          link: `https://support.microsoft.com/en-ca/help/17442/windows-internet-explorer-delete-manage-cookies`
        },
        {
          title: `Opera:`,
          link: `https://help.opera.com/en/latest/web-preferences/`
        },
        {
          title: `Safari:`,
          text: `Manage cookies and website data in Safari on Mac`,
          link: `https://support.apple.com/en-za/guide/safari/sfri11471/mac`
        },
        {
          title: `Firefox:`,
          link: `https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences`
        },
      ],
      howCanYouAvoid_content_2: `If you block or disable cookies on our website, you may be unable to access certain areas 
      of our website and certain functions and pages will not work in the usual way.`,
      changesToPolicy_title: `CHANGES TO THE COOKIE POLICY`,
      changesToPolicy_content_1: `We may update this policy from time to time. If we make significant changes, 
      we will let you know but please regularly check this policy to ensure you are aware of the most updated version.`,
      changesToPolicy_content_2: {
        text: `This Cookie Policy was last updated on `,
        date: `30th October 2019.`
      },
      changesToPolicy_content_3: `Terminal3 Inc., 
      San Francisco, CA 94103,
      United States
     `,
      changesToPolicy_content_4: `You may reach us via e-mail at info@terminal3.com`
    },
    pricingPage:{
      coveredPaymentSystems: [
        {
          countryCode: "global",
          country: "Global",
          paymentSystem: "Mastercard*",
          type: "Credit Card"
        },
        {
          countryCode: "global",
          country: "Global",
          paymentSystem: "American Express",
          type: "Credit Card"
        },
        {
          countryCode: "global",
          country: "Global",
          paymentSystem: "Alipay",
          type: "E-wallet"
        },
        {
          countryCode: "global",
          country: "Global",
          paymentSystem: "Wechat Payments",
          type: "E-wallet"
        },
        {
          countryCode: "AR",
          country: "Argentina",
          paymentSystem: "Bank Transfer Argentina",
          type: "Bank Transfer"
        },
        {
          countryCode: "AR",
          country: "Argentina",
          paymentSystem: "PagoFacil",
          type: "Prepaid"
        },
        {
          countryCode: "AR",
          country: "Argentina",
          paymentSystem: "RapiPago",
          type: "Prepaid"
        },
        {
          countryCode: "AU",
          country: "Australia",
          paymentSystem: "Poli",
          type: "Bank Transfer"
        },
        {
          countryCode: "AT",
          country: "Austria",
          paymentSystem: "SEPA Direct Debit*",
          type: "Bank Transfer"
        },
        {
          countryCode: "AT",
          country: "Austria",
          paymentSystem: "EPS*",
          type: "Bank Transfer"
        },
        {
          countryCode: "BE",
          country: "Belgium",
          paymentSystem: "SEPA Direct Debit*",
          type: "Bank Transfer"
        },
        {
          countryCode: "BE",
          country: "Belgium",
          paymentSystem: "KBC*",
          type: "Bank Transfer"
        },
        {
          countryCode: "BE",
          country: "Belgium",
          paymentSystem: "CBC*",
          type: "Bank Transfer"
        },
        {
          countryCode: "BE",
          country: "Belgium",
          paymentSystem: "Bancontact*",
          type: "Credit Card"
        },
        {
          countryCode: "CL",
          country: "Chile",
          paymentSystem: "Redcompra",
          type: "Prepaid"
        },
        {
          countryCode: "CL",
          country: "Chile",
          paymentSystem: "Davivienda",
          type: "Prepaid"
        },
        {
          countryCode: "CN",
          country: "China",
          paymentSystem: "Bank Transfer China",
          type: "Bank Transfer"
        },
        {
          countryCode: "CN",
          country: "China",
          paymentSystem: "UnionPay",
          type: "Credit Card"
        },
        {
          countryCode: "CO",
          country: "Colombia",
          paymentSystem: "Efecty",
          type: "Prepaid"
        },
        {
          countryCode: "EE",
          country: "Estonia",
          paymentSystem: "Bank Transfer Estonia*",
          type: "Bank Transfer"
        },
        {
          countryCode: "FI",
          country: "Finland",
          paymentSystem: "Bank Transfer Finland*",
          type: "Bank Transfer"
        },
        {
          countryCode: "FR",
          country: "France",
          paymentSystem: "SEPA Direct Debit*",
          type: "Bank Transfer"
        },
        {
          countryCode: "DE",
          country: "Germany",
          paymentSystem: "SEPA Direct Debit*",
          type: "Bank Transfer"
        },
        {
          countryCode: "ID",
          country: "Indonesia",
          paymentSystem: "Doku Wallet",
          type: "E-wallet"
        },
        {
          countryCode: "IT",
          country: "Italy",
          paymentSystem: "SEPA Direct Debit*",
          type: "Bank Transfer"
        },
        {
          countryCode: "KR",
          country: "Korea",
          paymentSystem: "Local Credit Card Korea",
          type: "Credit Card"
        },
        {
          countryCode: "KR",
          country: "Korea",
          paymentSystem: "KFTC Internet Banking*",
          type: "Bank Transfer"
        },
        {
          countryCode: "LV",
          country: "Latvia",
          paymentSystem: "Maxima*",
          type: "Prepaid"
        },
        {
          countryCode: "LV",
          country: "Latvia",
          paymentSystem: "Bank Transfer Latvia*",
          type: "Bank Transfer"
        },
        {
          countryCode: "LT",
          country: "Lithuania",
          paymentSystem: "Paypost*",
          type: "Prepaid"
        },
        {
          countryCode: "LT",
          country: "Lithuania",
          paymentSystem: "Maxima*",
          type: "Prepaid"
        },
        {
          countryCode: "LT",
          country: "Lithuania",
          paymentSystem: "Bank Transfer Lithuania*",
          type: "Bank Transfer"
        },
        {
          countryCode: "MY",
          country: "Malaysia",
          paymentSystem: "Bank Transfer Malaysia*",
          type: "Bank Transfer"
        },
        {
          countryCode: "MY",
          country: "Malaysia",
          paymentSystem: "Webcash",
          type: "E-wallet"
        },
        {
          countryCode: "MX",
          country: "Mexico",
          paymentSystem: "Bank Transfer Mexico",
          type: "Bank Transfer"
        },
        {
          countryCode: "MX",
          country: "Mexico",
          paymentSystem: "Bancomer Mexico",
          type: "Bank Transfer"
        },
        {
          countryCode: "MX",
          country: "Mexico",
          paymentSystem: "Banamex Mexico",
          type: "Bank Transfer"
        },
        {
          countryCode: "MX",
          country: "Mexico",
          paymentSystem: "Santander Mexico",
          type: "Bank Transfer"
        },
        {
          countryCode: "MX",
          country: "Mexico",
          paymentSystem: "Oxxo",
          type: "Prepaid"
        },
        {
          countryCode: "NL",
          country: "Netherlands",
          paymentSystem: "SEPA Direct Debit*",
          type: "Bank Transfer"
        },
        {
          countryCode: "NL",
          country: "Netherlands",
          paymentSystem: "iDeal*",
          type: "Bank Transfer"
        },
        {
          countryCode: "PE",
          country: "Peru",
          paymentSystem: "Bank Transfer Peru",
          type: "Bank Transfer"
        },
        {
          countryCode: "PL",
          country: "Poland",
          paymentSystem: "SEPA Direct Debit*",
          type: "Bank Transfer"
        },
        {
          countryCode: "PL",
          country: "Poland",
          paymentSystem: "Bank Transfer Poland",
          type: "Bank Transfer"
        },
        {
          countryCode: "PL",
          country: "Poland",
          paymentSystem: "Dotpay",
          type: "Bank Transfer"
        },
        {countryCode: "PL",
          country: "Poland",
          paymentSystem: "mTransfer",
          type: "Bank Transfer"
        },
        {countryCode: "PL",
          country: "Poland",
          paymentSystem: "Bank Zachodni WBK",
          type: "Bank Transfer"
        },
        {countryCode: "PL",
          country: "Poland",
          paymentSystem: "Pekao24 Przelew",
          type: "Bank Transfer"
        },
        {countryCode: "PL",
          country: "Poland",
          paymentSystem: "ING Bank Slaski",
          type: "Bank Transfer"
        },
        {countryCode: "PL",
          country: "Poland",
          paymentSystem: "Inteligo",
          type: "Bank Transfer"
        },
        {countryCode: "PL",
          country: "Poland",
          paymentSystem: "Place z ING Bank Slaski",
          type: "Bank Transfer"
        },
        {countryCode: "PL",
          country: "Poland",
          paymentSystem: "Przelewy24",
          type: "Bank Transfer"
        },
        {
          countryCode: "PT",
          country: "Portugal",
          paymentSystem: "SEPA Direct Debit*",
          type: "Bank Transfer"
        },
        {
          countryCode: "RU",
          country: "Russia",
          paymentSystem: "Webmoney",
          type: "E-wallet"
        },
        {
          countryCode: "RU",
          country: "Russia",
          paymentSystem: "Qiwi Wallet",
          type: "E-wallet"
        },
        {
          countryCode: "ES",
          country: "Spain",
          paymentSystem: "SEPA Direct Debit*",
          type: "Bank Transfer"
        },
        {
          countryCode: "CH",
          country: "Switzerland",
          paymentSystem: "SEPA Direct Debit*",
          type: "Bank Transfer"
        },
        {
          countryCode: "UY",
          country: "Uruguay",
          paymentSystem: "Redpagos",
          type: "Prepaid"
        }
      ]
    },
    signUp: {
      pageTitle: "Choose your solution",
      pageDescription: "Launch Terminal3 products. Choose product and go to your admin panel. You can switch between products any monent from your accout area.",
      product1Title: "Terminal3 shop",
      product1Description: "",
      product2Title: "",
      product2Description: "",
      product3Title: "",
      product3Description: "",

    },
    homePage: {
      meta: {
        title: "Sell Your Games Globally | Terminal3",
        description: "Built for game developers who want to sell globally - Terminal3 offers 150+ local payment methods, a customizable shop builder and much more.",
      },
      signUpButtonText: 'sign up',
      mainScreenSection: {
        title: `Sell\nyour games\nglobally`,
        description_part1: `Sell your game, in-game items, virtual currency, game and expansion packs. We help you do this flexibly with Terminal3 Payments, Terminal3`,
        description_part2: "E-Commerce",
        description_part3: "Shop Builder, and Global Marketplaces!",
      },
      paymentsSection: {
        title: "Terminal3 payments",
        description: `You can use Terminal3 Payments to process your in-game payments, subscriptions, pre-sales in all the global markets from within the game or using our Payment Widget.`,
        paymentMethods_text1: '150+',
        paymentMethods_text2: 'Payment methods',
        advantagesListTitle: "Benefits",
        advantagesList: [
          {
            id: "spaceman",
            title: "You focus on building, we focus on selling",
            description: `We provide risk monitoring, fraud mitigation, chargeback and dispute handling services in addition to 24/7 Customer Support Team available to answer any inquiry from you or your game users.`,
          },
          {
            id: "goal",
            title: "Full spectrum of payment options",
            description: `We provide a full spectrum of payment options across all regions from prepaid cards to local credit cards processing, local bank transfers, and e-wallets in local currencies.`,
          },
          {
            id: "rocket",
            title: "Launch your games anywhere!",
            description: `Whether you are a company registered in China, Hong Kong, Russia, Europe, or the US (190 countries in total), we can set up credit card and local alternative payment option accounts and get your processing payments within a day with one simple integration.`,
          },
          {
            id: "universe",
            title: "Fully customizable",
            description: `We have customizable payment widgets that can be made to look like your game, and that can integrate seamlessly with your game with robust APIs that have been running for the past 10 years, processing tens of billion of dollars.`,
          },
        ],
      },
      eCommerceShopSection: {
        title_part1: `Terminal3`,
        title_part2: `e-commerce shop builder`,
        description: `Create your own game shop with the Terminal3 E-Commerce Shop Builder, built from the ground up for digital and game inventory to sell globally. `,
        opportunitiesList: [
          {
            id: 'shop',
            title: 'Create a shop',
            description: `Create your own game shop and redirect your game URL to save on commissions paid to 3rd party sites.`,
          },
          {
            id: 'items',
            title: 'Add items',
            description: `List your in-game items and sell them directly in the shop or call the widget from within your game and sell within your game.`,
          },
          {
            id: 'inventory',
            title: 'Manage inventory',
            description: `Manage prices, inventory, get reports on sales and optimize cross-sells and up-sells.`,
          }
        ],
      },
      marketplaceSection: {
        title: "Terminal3 global marketplaces",
        description: `Some markets are difficult to reach due to regulation, local tax rules, local compliance, so with Terminal3, we created local entities to enable game companies to sell problem-free in these hard to reach markets.`,
        globalMarketplacesList: {
          "turkey": 'Turkey',
          "india": 'India',
          "philippines": 'Philippines',
          "vietnam": 'Vietnam',
          "brazil": 'Brazil',
          "europeanUnion": 'European Union',
        },
        optionsList: [
          "Local Payment Options", "Local Accounting", "Local Money Collection", "Local Compliance", "Local Customer Support", "Local VAT and Withholding Tax",
        ]
      },
      ourTeamBlock: {
        title: "Terminal3 team is close to you",
        description: `Whether you are a game developer in the US, Russia, China, Brazil, Korea, Europe or Southeast Asia, the Teminal3 team is close to you. You can meet with our team locally at one of our office locations or meet them at any global game conferences.`,
        ourOffices: [
          'San Francisco', 'Las Vegas', 'Berlin', 'London',
          'Lisbon', 'Sofia', 'Kyiv',  'Moscow',
          'Novosibirsk', 'Bangalore', 'Hanoi', 'Manila',
          'Beijing', 'Shenzhen', 'Sao Paulo', 'Seoul'
        ],
      },
      ourPartnersBlock: {
        title: "Trusted by global game companies",
        description: "Start selling your games globally",
      },
      eventsBlock: {
        title: "Find us at",
      },
      merchantBlock: {
        description: "Do you want to sell game with all business features unlocked?"
      }
    },
    contactUsPage: {
      meta: {
        title: "Contact Us | Terminal3",
        description: "Contact our sales team if you want to know more about how Terminal3 can sell your game globally.",
      },
      pageTitle: "Contact us",
      pageSubTitle: "Whether you are a game developer in the US, Russia, China, Europe or South East Asia, the terminal3 Team is close to you.",
      pageDescription_1: "The Terminal3 Team members sit in Paymentwall offices located in global tech cities. You can meet with our team locally at one of our office locations or meet them at many global game conferences.",
      pageDescription_2: "Contact us through the form below or simply email us:",
      pageDescriptionLink: "bizdev@terminal3.com",
      input_name: "Name",
      input_email: "Email",
      input_message: "Message",
      input_inquiryType: "Your inquiry type",
      input_inquiryTypePlaceholder: "Please select",
      input_inquiryTypesList: [
        {
          id: "payment",
          value: "Payment"
        },
        {
          id: "business",
          value: "Business"
        }
      ],
      errors: {
        required: 'This field is required',
      },
      button_title: "Send a request",
      feedback: {
        success: {
          thankYou: 'Thank you!',
          message: 'Your message has been successfully sent. \nWe will contact you as soon as possible.',
        },
        error: 'Sorry! Message wasn\'t sent.'
      },
      ourOfficesBlock: {
        title: "Our offices",
        list: [
          {
            title: "San Francisco",
            address_street: "255 9th St,",
            address_city: "San Francisco, CA, 94103,",
            address_country: "United States"
          },
          {
            title: "Berlin",
            address_street: "Friedrichstraße 88,",
            address_city: "Berlin, 10117,",
            address_country: "Germany"
          },
          {
            title: "London",
            address_street: "167 City Road,",
            address_city: "London, EC1V 1AW,",
            address_country: "United Kingdom"
          },
          {
            title: "Lisbon",
            address_street: "Av. Óscar Monteiro Torres 35A,",
            address_city: "Lisbon, 1000-216,",
            address_country: "Portugal"
          },
          {
            title: "Sofia",
            address_street: `Bul. "Gotse Delchev" 100,`,
            address_city: "1404 Motopista,",
            address_country: "Bulgaria"
          },
          {
            title: "Kyiv",
            address_street: "Pushkinska St. 45/2,",
            address_city: "Kyiv, 01004,",
            address_country: "Ukraine"
          },
          {
            title: "Moscow",
            address_street: "Novaya ploshchad',",
            address_city: "Moscow, 109012,",
            address_country: "Russia"
          },
          {
            title: "Novosibirsk",
            address_street: "Deputatskaya ulisa 46,",
            address_city: "Novosibirsk, 630099,",
            address_country: "Russia"
          },
          {
            title: "Guaron",
            address_street: "WeWork, Platina Tower, Mehrauli-Gurgaon Road,",
            address_city: "Gurugram, 122002, Haryana,",
            address_country: "India"
          },
          {
            title: "Bangalore",
            address_street: `Manandi Plaza, 3rd floor, St. Marks Rd,`,
            address_city: "Bengaluru, 560001, Karnataka",
            address_country: "India"
          },
          {
            title: "Hanoi",
            address_street: "48 To ngoc Van St.,",
            address_city: "Quang An Ward, Hanoi,",
            address_country: "Vietnam"
          },
          {
            title: "Manila",
            address_street: "Heart Tower Penthouse E, Valero St.,",
            address_city: "Makati City, Metro Manila,",
            address_country: "Philippines"
          },
          {
            title: "Beijing",
            address_street: "Building 15, North Taikoo Li, Sanlitun, Chaoyang,",
            address_city: "Beijing, 100027,",
            address_country: "China"
          },
          {
            title: "Shenzhen",
            address_street: "905A, 10B, Shenzen Bay Science and Technology Park, Nanshan,",
            address_city: "Shenzhen, 518057,",
            address_country: "China"
          },
          {
            title: "Seoul",
            address_street: "253, Pangyo-ro, Bundang-gu,",
            address_city: "Seongnam-si, Gyeonggi-do, 13486,",
            address_country: "Republic of Korea"
          },
          {
            title: "Sao Paolo",
            address_street: "Address will be updated soon",
            address_city: "",
            address_country: ""
          },
        ]
      }
    },
    aboutUsPage: {
      pageTitle: "About us",
      pageDescription_1: `Paymentwall started in 2010, as a Facebook-based, game monetization platform, and we quickly saw the need for "exotic" payment options as the games on Facebook attracted many users from developing countries in South East Asia, the game developers faced a challenge of increased server costs and low monetization.`,
      pageDescription_2: `We quickly added payment options from around the world to remedy this and helped companies generate revenue.`,
      pageDescription_3: `In 2011, Facebook launched Facebook Credits and eliminated other monetization providers, so Paymentwall took a path to become a full-fledged Payments institution with Payment licenses and compliance and expand into more verticals. We are currently operating with FINCEN and various US state licenses, and our Fasterpay brand has received an e-money license from the FCA in the UK and Paymentwall has also become a PSP in the UK, and recently has become a direct acquirer of many credit card schemes, excelling in the domain of payments whether it's credit cards or alternative payments. We are the only Payments company that has a full spectrum of payment options covering all different payment types. We also are PSI-DSS Level 1 certified since 2014.`,
      pageDescription_4: `In 2018, we announced Terminal3, a new brand that will be gaming focused where we service both the end-users of games as we have always have done, and the game companies in helping expand to new regions. We also saw a need to launch e-commerce functionality to help game companies sell directly to their users, in an ever-competitive and monopolized game distribution space.`,
      pageDescription_5: `In 2019, at E3, we complete the full cycle of conferences and announcement of our new brand and we will complete the transition.`,
      pageDescription_6: `We will offer the new features listed on the front page of our brochure.`,
      pageDescription_7: `Let's sell your games globally with Terminal3!`
    },
    supportCenterPage: {
      meta: {
        title: "Support | Terminal3",
        description: "Terminal3 support center provides the answer to a range of questions including chargebacks, refunds, Terminal3 information and more.",
      },
      pageTitle: "Support center",
      pageAside: {
        title: "Table of content",
        searchboxPlaceholder: "Search",
        contentList: [
          "Payment methods",
          "Payments",
          "Payment Verification",
          "Payment Verification",
          "integrations",
          "GDPR"
        ]
      },
      search: {
        placeholder: 'Search...',
        noResultsText: 'No articles were found.'
      },
      sections: [
        {
          id: "payment-methods",
          title: "Payment methods",
          details: [
            {
              id: "how-many-payment-methods-do-you-have",
              title: "How many payment methods do you have?",
              description: `Terminal3 partners with global payments processing companies to provide online billing solution with over 120 payment methods which include e-wallets, mobile and land-line payments, prepaid cards, payment kiosks, debit cards, bank transfers and more. All of these payment options will allow you to monetize users from all over the world whether you are selling virtual goods in a game or provide online services.`,
            },
            {
              id: "i-already-offer-credit-card-payments-to-my-users-what-else-do-i-need",
              title: "I already offer credit card payments to my users. What else do I need?",
              description: `You are only covering a percentage of your users. By signing up with Terminal3, you will have full coverage in more than 200 countries with local options for each of these markets. If you cannot decide which payment options to set up, you can work closely with our optimization team in getting the most out of Terminal3's services.`,
            }
          ]
        },
        {
          id: "payments",
          title: "Payments",
          details: [
            {
              id: "am-i-being-charged-for-initiated-payments",
              title: "Am I being charged for 'Initiated' payments?",
              description: `Initiated payments mean that your purchase is either pending or did not go through successfully. Pending transactions are normally applicable for payment methods that need further processing such as bank transfers. Otherwise, we assure you that you will not be charged for ‘Initiated’ payments.`,
            },
            {
              id: "how-do-i-cancel-recurring-billing-for-a-subscription",
              title: "How do I cancel recurring billing for a subscription?",
              description: `To cancel your recurring billing to a website or an application, just go to the Terminal3 payment page on the website you made a purchase and click on the "Help" button. Go to the "Recurring Payments" tab to see your active recurring subscriptions. Click on cancel.`,
            },
            {
              id: "how-can-i-add-my-preferred-payment-method",
              title: "How can I add my preferred payment method?",
              description: `Click the ‘Help’ button on the page where you make a purchase. You can find this on the upper right part of the checkout page. You will see an option to request for a payment method you prefer, which is currently unavailable to you.`,
            },
            {
              id: "how-can-i-check-my-previous-payments",
              title: "How can I check my previous payments?",
              description: `In order to check your previous payments, you can create or sign in to your own Terminal3 Account. Payments history will be available for you right after sign up.`,
            },
            {
              id: "do-you-store-my-credit-card-details",
              title: "Do you store my credit card details?",
              description: `Terminal3 does not store credit card details. However, make sure that in your browser settings ‘Autofill’ or ‘Autocompletion’ options turned off to protect yourself from possible fraud actions.`,
            },
            {
              id: "how-can-i-remove-autofill-of-my-credit-card-details",
              title: "How can I remove autofill of my credit card details?",
              description: `In order to remove autofill of your credit card details, you should change special settings in your browser. You may refer to the following sites on how to remove this feature:
                Google Chrome Safari Mozilla Firefox`,
            }
          ]
        },
        {
          id: "payment-verification",
          title: "Payment Verification",
          details: [
            {
              id: "why-was-my-payment-blocked",
              title: "Why was my payment blocked?",
              description: `Terminal3 fraud protection works to provide a high level of security and safety for our customers. We perform fraud check to verify our users and for faster processing of future payments.`,
            },
            {
              id: "i-dont-have-a-scanner-to-scan-a-photo-of-my-card-or-id-what-should-i-do",
              title: "I don't have a scanner to scan a photo of my card or ID. What should I do?",
              description: `You can take a photo of your card using your mobile phone. Please make sure that the first 6 digits and the last 4 digits are visible. The photo capture also needs to show the name on the card and the expiry date. All other information on the cards should be hidden.`,
            },
            {
              id: "is-it-secure-for-me-to-upload-a-scanned-copy-of-my-personal-id",
              title: "Is it secure for me to upload a scanned copy of my personal ID?",
              description: `By using Terminal3, which is compliant with the strictest PCI requirements, your data is secure and protected. PCI DSS (Payment Card Industry Data Security Standard) is the standard that would protect the data of customers, as well as ensure the proper transfer of their data and implementation/handling of debit and credit card transactions.`,
            },
            {
              id: "do-i-need-to-upload-my-documents-each-time-i-pay",
              title: "Do I need to upload my documents each time I pay?",
              description: `Transaction verification is a one-time procedure. You can be sure that your future payments made with the same card or verified payment system will go through automatically without any delay.`,
            },
            {
              id: "in-case-i-change-my-mind-to-make-the-payment-during-the-transaction-verification-how-can-i-cancel-my-payment",
              title: "In case I change my mind to make the payment during the transaction verification, how can I cancel my payment?",
              description: `If you don't provide the documents within the requested period, we will cancel your purchase automatically and you won't be charged. If you used an e-wallet to make a purchase, your payment will be refunded within 7 to 10 days.`,
            }
          ]
        },
        {
          id: "payouts",
          title: "Payouts",
          details: [
            {
              id: "how-can-i-receive-my-payout",
              title: "How can I receive my payout?",
              description: `Terminal3 can pay you via the following methods:

            Bank and Wire Transfer (Globally) Check (US only) PayPal (Globally)
            `,
            },
            {
              id: "how-often-can-i-receive-my-payouts",
              title: "How often can I receive my payouts?",
              description: `You receive payouts once a month. If your monthly revenues are greater than $100,000 we can send payouts twice a month.`,
            },
            {
              id: "i-am-still-a-minor-can-i-receive-my-payout",
              title: "I am still a minor. Can I receive my payout?",
              description: `If you are a minor and would like to use our service. Kindly ask your parents or legal guardians to accept the payout on your behalf. In compliance with international laws, we require the beneficiary of the payout to be of legal age.`,
            },
            {
              id: "in-which-currency-can-i-receive-my-payout",
              title: "In which currency can I receive my payout?",
              description: `We can send the payout in USD or EUR provided that the bank used for the deposit is denominated in this currency.`,
            },
            {
              id: "is-there-any-minimum-payout-amount-that-i-need-to-meet",
              title: "Is there any minimum payout amount that I need to meet?",
              description: `There is a $100 minimum payout threshold. Once the $100 threshold is met, we will automatically send you the payout as long as all compliance documents are uploaded and approved.`,
            },
            {
              id: "why-are-you-not-sending-my-payout",
              title: "Why are you not sending my payout?",
              description: `In order to receive your payout, please make sure that all required Compliance documents are submitted and approved. Check out your payout settings page for the complete list of required documents.`,
            },
            {
              id: "why-is-my-payout-delayed",
              title: "Why is my payout delayed?",
              description: `We send out payouts as we collect your revenues from our payment partners. It would depend on the payment method utilized by the users and release time of our payment partners which usually vary between 30 to 60 days. To view your payout schedule, please click here.

            The payout can also be put on hold for a specific amount of time if we see that you have stopped processing payments. This is to cover any possible chargebacks the users may file. Once the prescriptive period is over, we will pay you your remaining balance minus any refunds or chargebacks.
            `,
            }
          ]
        },
        {
          id: "integrations",
          title: "Integrations",
          details: [
            {
              id: "what-is-a-pingback",
              title: "What is a pingback?",
              description: `When a user makes a payment or completes an advertising offer via Offerwall, we send you an HTTP/HTTPS server-to-server notification communicating their user id and the details of the purchase. We call this notification a pingback.

            Once you receive a pingback from Terminal3, you will need to deliver the purchased product (or virtual currency) to the respective user. For this you will need to build a pingback listener script on your server. You should input the URL of this script (Pingback URL) in the Pingback section of your Project Settings inside of your Terminal3 Merchant Account.
            
            Follow the guidelines for the Pingback URL samples script (based on API type):
            
            Digital Goods
            
            Virtual Currency`,
            },
            {
              id: "how-can-i-set-up-a-pingback",
              title: "How can I set up a pingback?",
              description: `You can refer to the Getting Started page for instructions on how to set up a pingback. You may also check our Digital Goods, Virtual Currency, or Cart APIs' pages for details on the Pingback API format. Upon receiving a pingback and processing the order on your side, we also recommend implementing the Delivery Confirmation API so that Terminal3 can track the order status (in case of non-instant delivery) and update users in case they inquire about the payment status and so that Terminal3 can dispute possible chargebacks.`,
            },
            {
              id: "how-can-i-add-custom-pingback-parameters",
              title: "How can I add custom pingback parameters?",
              description: `You can set up custom pingback parameters in My Projects > Settings > Custom Pingback Parameters section. Any custom parameters can be added by specifying their name and value.

            For elaborate instructions, check out the pingback parameters page.`,
            },
            {
              id: "what-is-the-difference-between-http-and-email-pingback",
              title: "What is the difference between HTTP and Email Pingback?",
              description: `HTTP request is sent from our servers to your Pingback listener script where we communicate to your server the details about the payment so that your server can process the pingback and deliver the product or virtual currency to the according to user automatically.

            With Email Pingback an email is sent to the address that you configure once a user pays or completes an offer. Once you receive the email, you should deliver the product manually to the user.
            
            Note: We highly recommend using HTTP Pingback for automatic processing of orders.
            `,
            },
            {
              id: "which-shopping-cart-plugins-does-terminal3-support",
              title: "Which shopping cart plugins does Terminal3 support?",
              description: `We have plugins for several shopping carts, and we continuously add more, including:
            WordPress - Enjin/Buycraft - PrestaShop - WHMCS - OpenCart - Magento - CS-Cart - Drupal, Ubercart - Typo3
            Check out our shopping cart plugins page for the full list of integrations
            `,
            },
          ]
        },
        {
          id: "gdpr",
          title: "GDPR",
          details: [
            {
              id: "what-is-gdpr",
              title: "What is GDPR?",
              description: `The General Data Protection Regulation (GDPR) is the European Union’s new data protection law, which enters into force on May 25th, 2018. Its provisions were designed based on the idea that privacy is a fundamental human right. GDPR requires all companies receiving personal information from EU users to follow strict rules regarding the collection, use, and disclosure of all EU user, merchant and employee data.`,
            },
            {
              id: "does-terminal3-comply-with-gdpr",
              title: "Does Terminal3 comply with GDPR?",
              description: `Terminal3 implements comprehensive privacy and information security program to help us comply with GDPR. With the needs of our end users and merchants are at the forefront, we have developed an information privacy program that meets their needs and allows them to make free, informed decisions.`,
            },
            {
              id: "what-personal-data-does-terminal3-have-about-me",
              title: "What personal data does Terminal3 have about me?",
              description: `If you have a Terminal3 User Account, simply Terminal3 to view the data. If you have any further questions, feel free to contact us at support@terminal3.com to get assistance from our team.`,
            },
            {
              id: "how-can-i-request-for-my-data-to-be-updated-or-deleted",
              title: "How can I request for my data to be updated or deleted?",
              description: `If you have a Terminal3 User Account, simply l og in to create a request. If you have any further questions, feel free to contact us at support@terminal3.com to get assistance from our team.`,
            }
          ]
        }
      ],
    }
  },
  kr: {
    store: {
      test: '테스트 현지화',
    },
    shared: {
      signUp: "가입하기",
      contactUs: "고객센터",
      logIn: "로그인",
      createBusinessAccount: "비즈니스 계정 가입하기t",
      solutions: "솔루션",
      terminal3Payments: "결제 솔루션",
      eCommerceShopBuilder: "이커머스 숍 빌더",
      globalMarketplaces: "글로벌 마켓플레이스",
      developers: "연동문서",
      support: "서포트",
      followUsOnSocialMedia: "소셜미디어",
      home: "home",
      youAreTooFarFrom: "You are too far from",
      goBack: '이전 페이지로 돌아갑니다.',
    },
    contactUsPage: {
      meta: {
        title: "고객센터 | Terminal3",
        description: "전 세계로의 시장 확장 및 수익 창출을 모색하고 계시다면 저희 세일즈 팀으로 문의해 주시기 바랍니다",
      },
      pageTitle: "고객센터",
      pageSubTitle: "미국, 러시아, 중국, 브라질, 한국, 유럽, 혹은 동남아에서 게임을 개발하고 계시나요? Terminal3는 항상 당신 가까이에 있습니다.",
      pageDescription_1: "Terminal3 팀은 세계 주요 글로벌 테크 도시에서 찾으실 수 있습니다. 당신의 국가에 있는 Terminal3 팀을 찾으시거나 글로벌 게임 컨퍼런스에서 Terminal3 팀을 만나보세요.",
      pageDescription_2: "이메일 문의",
      pageDescriptionLink: "bizdev@terminal3.com",
      input_name: "이름",
      input_email: "이메일",
      input_message: "메시지",
      input_inquiryType: "문의 유형",
      input_inquiryTypePlaceholder: "선택",
      input_inquiryTypesList: [
        {
          id: "payment",
          value: "결제 관련 문의"
        },
        {
          id: "business",
          value: "서비스 문의"
        }
      ],
      errors: {
        required: '해당 입력란은 필수 입력 사항입니다',
      },
      button_title: "요청 보내기",
      feedback: {
        success: {
          thankYou: '감사합니다.',
          message: '당신의 메시지는 성공적으로 전송되었습니다.\n빠른 시일 내에 연락드리겠습니다',
        },
        error: '죄송합니다. 메시지가 발송되지 않았습니다.'
      },
    },
    homePage: {
      meta: {
        title: "당신의 게임을 전세계에 판매하세요 | Terminal3",
        description: "인게임 아이템, 가상 화폐, 게임 및 확장팩을 Terminal3 결제, Terminal3 이커머스 숍 빌더, Terminal3 글로벌 마켓플레이스 올인원 솔루션을 사용해서 판매해보세요!",
      },
      signUpButtonText: '시작하기',
      mainScreenSection: {
        title: `당신의 게임,\n전 세계 판매를\n시작하세요`,
        description_part1: `인게임 아이템, 가상 화폐, 게임 및 확장팩을 Terminal3 결제,`,
        description_part2: "Terminal3 이커머스 숍 빌더,",
        description_part3: "Terminal3 글로벌 마켓플레이스 올인원 솔루션을 사용해서 판매해보세요!",
      },
      paymentsSection: {
        title: "Terminal3\n결제 솔루션",
        description: `Terminal3 결제 솔루션을 사용하여 모든 글로벌 시장에서의 인게임 결제, 정기 결제, 프리세일즈를 진행 하실 수 있으며, 당사의 결제 위젯을 사용하여 결제를 받거나 인게임에서 직접 결제를 받을 수 있습니다.`,
        paymentMethods_text1: '150+',
        paymentMethods_text2: '이상의 결제수단',
        advantagesListTitle: "혜택제공",
        advantagesList: [
          {
            id: "spaceman",
            title: "게임 개발만 하세요.\n판매는 Terminal3가 하겠습니다.",
            description: `리스크 모니터링, 사기 거래 방지 필터링,\n차지백 사전/사후 매니징, 결제 관련 문의에 대한 24/7\n고객 센터 서비스 등을 모두 제공합니다.`,
          },
          {
            id: "goal",
            title: "올인원 결제 수단",
            description: `신용카드 결제, 선불카드, 현지 계좌이체 및 현지 통화 지원 가능한 E-Wallet까지 전세계를 커버할 수 있는 모든 결제 수단을 한 번에 제공합니다.`,
          },
          {
            id: "rocket",
            title: "전 세계로 게임을 런칭하세요!",
            description: `당신이 중국, 홍콩, 러시아, 유럽 또는 미국 등 전 세계 총 190개 국가 어느 국가에 있는지에 관계 없이, Terminal3를 통해 한 번의 간단한 통합으로 신용 카드 및 대체 결제를 시작할 수 있습니다.`,
          },
          {
            id: "universe",
            title: "커스터마이징",
            description: `Terminal3는 지난 10년 동안 수 많은 게임 회사의 수백억 달러 이상의 결제 대금을 처리해왔습니다. 완벽하게 커스터마이징이 가능한 결제 위젯들을 Terminal3의 강력한 API를 이용해 당신의 게임에 연동하세요.`,
          },
        ],
      },
      eCommerceShopSection: {
        title_part1: `Terminal3`,
        title_part2: `이커머스 숍 빌더`,
        description: `Terminal3의 이커머스 숍 빌더로 당신만의 게임 숍을\n 제작하고 당신의 게임과 디지털 상품을 전세계에 판매\n하세요!`,
        opportunitiesList: [
          {
            id: 'shop',
            title: '숍 만들기',
            description: `자신만의 게임 숍을 만들고 게임 URL을 리디렉션하여 타사 사이트에 지불하는 커미션 비용을 절약하세요.`,
          },
          {
            id: 'items',
            title: '아이템 올리기',
            description: `인게임 아이템을 등록하고 숍에서 직접 판매하거나, 위젯을 이용해서 당신의 게임안에서 판매할 수 있도록 리디렉팅하세요.`,
          },
          {
            id: 'inventory',
            title: '인벤토리 관리',
            description: `가격과 재고를 관리하고 세일즈 리포트를 받아보며 여러분의 비즈니스를 최적화하세요.`,
          }
        ],
      },
      marketplaceSection: {
        title: "Terminal3\n글로벌\n마켓플레이스",
        description: `특정 국가의 경우 엄격한 규제나 현지 세법, 준법감시등의 문제 때문에 진입하기 어렵습니다 Terminal3는 여러분이 현지 법인 없이도 해당 시장에서 게임을 판매할 수 있도록 지원합니다.`,
        globalMarketplacesList: {
          "turkey": '터키',
          "india": '인도',
          "philippines": '필리핀',
          "vietnam": '베트남',
          "brazil": '브라질',
          "europeanUnion": '유럽연합',
        },
        optionsList: [
          "현지 결제 수단", "현지 회계", "현지 정산", "현지 준법감시", "현지 고객 지원", "현지 VAT 및 원천과세",
        ]
      },
      ourTeamBlock: {
        title: "Terminal3 팀은 언제나 당신 가까이 있습니다",
        description: `미국, 러시아, 중국, 브라질, 한국, 유럽, 혹은 동남아에서 게임을 개발하고 계시나요? Terminial3는 항상 당신 가까이에 있습니다.`,
        ourOffices: [
          '샌프란시스코', '라스베가스', '베를린', '런던',
          '리스본', '소피아', '키예프',  '모스크바',
          '노보시비르스크', '방갈로르', '하노이', '마닐라',
          '베이징', '선전', '상파울루', '서울'
        ],
      },
      ourPartnersBlock: {
        title: "전세계 게임 회사가 신뢰합니다",
        description: "당신의 게임을 전세계에 판매하세요",
      },
      eventsBlock: {
        title: "컨퍼런스 참가",
      },
      merchantBlock: {
        description: "모든 기능을 활용해 게임을 판매하시겠습니까?"
      }
    }
  },
  ru: {
    store: {
      test: 'тестирование локализации',
    }
  },
  tr: {
    store: {
      test: 'yerelleştirme testi',
    }
  },
  cn: {
    store: {
      test: '本地化測試',
    },
    shared: {
      signUp: "注册",
      contactUs: "联系我们",
      logIn: "登录",
      createBusinessAccount: "创建企业账户",
      solutions: "解决方案",
      terminal3Payments: "支付渠道",
      eCommerceShopBuilder: "网上商店编辑器",
      globalMarketplaces: "全球市集",
      developers: "开发者",
      support: "技术支持",
      followUsOnSocialMedia: "关注我们的社交媒体账号",
      home: "回到首页",
      youAreTooFarFrom: "页面不存在",
      goBack: '返回上一页面',
    },
    contactUsPage: {
      meta: {
        title: "联系我们 | Terminal3",
        description: "想要了解更多有关Terminal3如何助您触达全球市场，请联系我们的销售团队",
      },
      pageTitle: "联系我们",
      pageSubTitle: "不论您是来自美国、俄罗斯、中国、巴西、韩国、欧洲还是东南亚的游戏开发商，Terminal3团队与您近在咫尺",
      pageDescription_1: "您可以与我们在不同国家和地区的办公室与本地团队会面洽谈，或者也可以在全球各大游戏展会上与我们会面我们常年出席美国旧金山的游",
      pageDescription_2: "或者您也可以直接邮件联系我们",
      pageDescriptionLink: "bizdev@terminal3.com",
      input_name: "名稱",
      input_email: "電子郵件",
      input_message: "信息",
      input_inquiryType: "咨询类别",
      input_inquiryTypePlaceholder: "请选择",
      input_inquiryTypesList: [
        {
          id: "payment",
          value: "支付"
        },
        {
          id: "business",
          value: "业务"
        }
      ],
      errors: {
        required: '必填项',
      },
      feedback: {
        success: {
          thankYou: '谢谢！',
          message: '您的信息已成功提交 \n我们会尽快与您联系！',
        },
        error: '抱歉！信息未发送成功'
      },
      button_title: "發送請求",
    },
    homePage: {
      meta: {
        title: "将您的游戏销往全球各地 | Terminal3",
        description: "专为开拓海外市场的游戏开发商而设计 - Terminal3提供150多种本地支付方式、可定制化网上商店编辑器及更多其他功能",
      },
      signUpButtonText: '注册',
      mainScreenSection: {
        title: `游戏出海\n全球触达`,
        description_part1: `使用Terminal3支付渠道、\n`,
        description_part2: "Terminal3网上商店",
        description_part3: "\n和Terminal3全球市集功能、\n您可以通过更灵活的方式\n销售您的游戏产品、 游戏内商品,\n虚拟货币及游戏扩展包",
      },
      paymentsSection: {
        title: `Terminal3 \n支付渠道`,
        description: `您可以使用Terminal3支付渠道在全球市场范围内处理您的游戏应用内付款、订阅和预售交易、而这些功能既能通过游戏内集成插件的形式实现、也可以通过将用户引导至Terminal3快速付款插件来完成`,
        paymentMethods_text1: '150+',
        paymentMethods_text2: '支付方式',
        advantagesListTitle: "优势",
        advantagesList: [
          {
            id: "spaceman",
            title: "您专注游戏开发\nTerminal3专注销售",
            description: `Terminal3设有24小时客服团队、可以帮助您或您的游戏用户随时答疑解惑。初次之外、Terminal3还提供风险监控、欺诈缓解、退款和争议处理服务。`,
          },
          {
            id: "goal",
            title: "全方位支付渠道",
            description: `Terminal3提供覆盖全球几乎所有地区的全方位支付渠道：从预付卡到本地信用卡处理、本地银行转账和使用当地货币的电子钱包。`,
          },
          {
            id: "rocket",
            title: "让您的游戏无处不在",
            description: `无论您的公司注册地是在中国大陆、中国香港、俄罗斯、欧洲还是在美国（共190个国家）、Terminal3都可以设置信用卡和本地替代支付渠道账户、只需一次简单地集成便能在一天之内开始处理付款交易。`,
          },
          {
            id: "universe",
            title: "高度可定制化",
            description: `Terminal3拥有众多可定制化的付款插件、可以完美匹配到您的游戏界面、并且付款插件可以与您的游戏无缝集成、这得益于Terminal3后台强大的API接口能力、在过去10年中已经处理了数百亿美元交易。`,
          },
        ],
      },
      eCommerceShopSection: {
        title_part1: `Terminal3`,
        title_part2: `网上商店编辑器`,
        description: `使用Terminal3网上商店编辑器、从零开始创建自己的线上商店、\n实现全球范围内的数字商品及游戏交易`,
        opportunitiesList: [
          {
            id: 'shop',
            title: '创建商店',
            description: `创建您自己网上游戏商店、并重定向游戏链接以节省第三方平台佣金`,
          },
          {
            id: 'items',
            title: '增加项目',
            description: `列出游戏内虚拟商品直接在网上商店销售、或设置商品展示插件在游戏界面内销售`,
          },
          {
            id: 'inventory',
            title: '管理库存',
            description: `管理定价和库存、获取销售数据报告、并优化交叉销售和追加销售`,
          }
        ],
      },
      marketplaceSection: {
        title: `Terminal3\n全球市集`,
        description: `由于监管、地方税收法规和本地合规等客观因素、导致某些国家和市场准入难度较大。因此、Terminal3通过在当地设立商业实体、以帮助游戏公司轻松无忧的拓展这些难以触及的市场。`,
        globalMarketplacesList: {
          "turkey": '土耳其',
          "india": '印度',
          "philippines": '菲律宾',
          "vietnam": '越南',
          "brazil": '巴西',
          "europeanUnion": '欧盟',
        },
        optionsList: [
          "本地支付渠道", "本地会计", "本地资金收款", "本地合规", "本地客服支持", "本地增值税和预扣税",
        ]
      },
      ourTeamBlock: {
        title: `Terminal3\n团队就在您身边`,
        description: `不论您是来自美国、俄罗斯、中国、巴西、韩国、欧洲还是东南亚的游戏开发商、Terminal3团队与您近在咫尺。您可以与我们在不同国家和地区的办公室与本地团队会面洽谈、或者也可以在全球各大游戏展会上与我们会面`,
        ourOffices: [
          '旧金山', '拉斯維加斯', '柏林', '伦敦',
          '里斯本', '索非亚', '基辅',  '莫斯科',
          '新西伯利亚', '班加罗尔', '胡志明市', '马尼拉',
          '北京', '深圳', '圣保罗', '首尔'
        ],
      },
      ourPartnersBlock: {
        title: "备受全球知名游戏公司信赖",
        description: "现在就开始让您的游戏销往世界各地",
      },
      eventsBlock: {
        title: "联系我们",
      },
      merchantBlock: {
        description: "您想解锁全部企业账户功能吗？"
      }
    },
  },
  id: {
    store: {
      test: 'pengujian lokalisasi',
    }
  },
  br: {
    store: {
      test: 'teste de localização',
    }
  },
  de: {
    store: {
      test: 'Testlokalisierung',
    }
  }
});

export function I18nContext(WrappedComponent) {
  return class Component extends Component {
      setLanguage = (lang) => {
        strings.setLanguage(lang);
        this.setState({});
      }

      render() {
        return (
          <WrappedComponent
            setLanguage={this.setLanguage}
            {...this.props}
          />
        );
      }
  };
}

export default strings;



// WEBPACK FOOTER //
// ./src/utils/translationStrings.js